import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Button } from "../components/ui/button";
import { Sparkles, Gift, Check, ArrowRight, Star } from "lucide-react";

export default function Pricing() {
  const { t } = useTranslation();

  return (
    <div className="max-w-4xl mx-auto px-6 py-16" data-testid="pricing-page">
      <div className="text-center mb-12">
        <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-amber-50 border border-amber-200 text-amber-800 text-xs font-semibold uppercase tracking-wider mb-5">
          <Gift className="w-3.5 h-3.5" />
          {t("free_launch.banner_label")}
        </div>
        <h1 className="font-display text-4xl sm:text-5xl font-bold text-slate-900 mb-4 leading-tight">
          {t("free_launch.title")}
        </h1>
        <p className="text-lg text-slate-600 max-w-2xl mx-auto leading-relaxed">
          {t("free_launch.subtitle")}
        </p>
      </div>

      <div className="mec-card p-8 lg:p-12 mb-10">
        <div className="flex items-center justify-center mb-6">
          <div className="w-14 h-14 rounded-xl bg-gradient-to-br from-amber-400 to-amber-600 flex items-center justify-center">
            <Star className="w-7 h-7 text-white" />
          </div>
        </div>

        <h2 className="font-display text-2xl font-bold text-slate-900 text-center mb-2">
          {t("free_launch.everything_included")}
        </h2>
        <p className="text-sm text-slate-600 text-center mb-8">
          {t("free_launch.no_card_required")}
        </p>

        <div className="grid md:grid-cols-2 gap-x-8 gap-y-3 max-w-2xl mx-auto mb-8">
          <FeatureLine text={t("free_launch.feature_1")} />
          <FeatureLine text={t("free_launch.feature_2")} />
          <FeatureLine text={t("free_launch.feature_3")} />
          <FeatureLine text={t("free_launch.feature_4")} />
          <FeatureLine text={t("free_launch.feature_5")} />
          <FeatureLine text={t("free_launch.feature_6")} />
          <FeatureLine text={t("free_launch.feature_7")} />
          <FeatureLine text={t("free_launch.feature_8")} />
        </div>

        <div className="flex flex-col sm:flex-row gap-3 justify-center">
          <Link to="/register" data-testid="cta-register-candidate">
            <Button className="bg-[#004EEB] hover:bg-[#003BCC] text-white w-full sm:w-auto">
              <Sparkles className="w-4 h-4 mr-2" />
              {t("free_launch.cta_candidate")}
              <ArrowRight className="w-4 h-4 ml-2" />
            </Button>
          </Link>
          <Link to="/register" data-testid="cta-register-employer">
            <Button variant="outline" className="border-slate-300 text-slate-700 hover:bg-slate-50 w-full sm:w-auto">
              {t("free_launch.cta_employer")}
              <ArrowRight className="w-4 h-4 ml-2" />
            </Button>
          </Link>
        </div>
      </div>

      <div className="text-center text-sm text-slate-500 leading-relaxed">
        <p className="text-xs">{t("free_launch.gdpr_notice")}</p>
      </div>
    </div>
  );
}

function FeatureLine({ text }) {
  return (
    <div className="flex items-start gap-2 text-sm text-slate-700">
      <Check className="w-4 h-4 text-emerald-600 mt-0.5 flex-shrink-0" />
      <span>{text}</span>
    </div>
  );
}
